document.getElementById("register-email").addEventListener("input", function () {
  const mail = document.getElementById("register-email").value;

  if (mail != "" && !mail.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\._-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)) {
    document.getElementById("email-error").classList.add("show");
  } else {
    document.getElementById("email-error").classList.remove("show");
  }
});

document.querySelectorAll("input, select").forEach((element) => {
  element.addEventListener("change", function () {
    if (document.getElementById("mail-confirm").value !== "" && document.getElementById("register-email").value !== document.getElementById("mail-confirm").value) {
      document.getElementById("email-confirm-error").classList.add("show");
    } else {
      document.getElementById("email-confirm-error").classList.remove("show");
    }

    if (document.getElementById("password-confirm").value !== "" && document.getElementById("register-password").value !== document.getElementById("password-confirm").value) {
      document.getElementById("password-confirm-error").classList.add("show");
    } else {
      document.getElementById("password-confirm-error").classList.remove("show");
    }

    if (document.getElementById("register-last-name").value === "" || document.getElementById("register-first-name").value === "" || document.getElementById("register-kana-1").value === "" || document.getElementById("register-kana-2").value === "" || document.getElementById("register-email").value === "" || document.getElementById("mail-confirm").value === "" || document.getElementById("register-gender").value === "" || document.getElementById("birthday-year").value === "" || document.getElementById("birthday-month").value === "" || document.getElementById("birthday-date").value === "" || document.getElementById("birthday-job").value === "" || document.getElementById("register-password").value === "" || document.getElementById("password-confirm").value === "" || document.getElementById("email-error").classList.contains("show") || document.getElementById("register-check").checked == false) {
      document.getElementById("register-submit").classList.add("disable");
      document.getElementById("register-error").classList.add("show");
    } else {
      if (document.getElementById("register-email").value === document.getElementById("mail-confirm").value && document.getElementById("register-password").value === document.getElementById("password-confirm").value) {
        document.getElementById("register-submit").classList.remove("disable");
        document.getElementById("register-error").classList.remove("show");
      } else {
        document.getElementById("register-submit").classList.add("disable");
        document.getElementById("register-error").classList.add("show");
      }
    }
  });
});

document.getElementById("register-submit").addEventListener("click", function () {
  if (!document.getElementById("register-submit").classList.contains("disable")) {
    document.querySelectorAll(".recruit__form").forEach((element) => {
      element.classList.remove("current");
    });

    document.getElementById("terms").classList.add("current");
  }
});

document.getElementById("terms-deny").addEventListener("click", function () {
  document.querySelectorAll(".recruit__form").forEach((element) => {
    element.classList.add("current");
  });

  document.getElementById("terms").classList.remove("current");
});

const keyword = "メールアドレスを認証するために、メール上のリンクをクリックしてください。";
let existing = false;

document.querySelectorAll(".register-error-message *").forEach((element) => {
  if (element.textContent.includes(keyword)) {
    existing = true;
  }
});

if (existing) {
  document.getElementById("registerItems").style.display = "none";
  document.getElementById("registerTop").style.display = "none";
  document.getElementById("registerErrorMessage").style.marginTop = "40px";
}
